<hmf-progress-ring
	[variant]="'gold'"
	[targetBalance]="salesTarget"
	[currentBalance]="currentSalesBalance()"
	[animateLoading]="isGold()"
	[goldThruDate]="goldThruDate()"
	[size]="size()"
	[balanceDescriptor]="goldDescriptor()">
</hmf-progress-ring>
